import { AllColors, Typo } from 'components/ui-kit';
import styles from './aside-info-line.module.scss';

type AsideVariant = 'xl' | 'l' | 's';

type TAsideInfoLineProps = {
  left: string | JSX.Element;
  right: string | JSX.Element;
  variant?: AsideVariant;
  color?: AllColors;
};

const WIGHT_BY_VARIANT: Record<AsideVariant, '500' | '400' | '600'> = {
  l: '500',
  s: '400',
  xl: '600',
};

const TYPO_VARIANT_BY_VARIANT: Record<AsideVariant, 'm' | 'xl' | 'l'> = {
  l: 'l',
  s: 'm',
  xl: 'xl',
};

export const AsideInfoLine = ({
  left,
  right,
  variant = 'l',
  color = 'primary',
}: TAsideInfoLineProps): JSX.Element => {
  return (
    <Typo
      weight={WIGHT_BY_VARIANT[variant] ?? '500'}
      variant={TYPO_VARIANT_BY_VARIANT[variant]}
      color={color}
    >
      <div className={styles.cartPageAsideInfoLine}>
        <div>{left}</div>
        <div className={styles.cartPageAsideInfoLineRight}>{right}</div>
      </div>
    </Typo>
  );
};
